import React, { useEffect } from 'react';
import { TabsBar } from '../../../shared/components/Tab/Tabs';
import { Card, VideoContainer } from './styles';
import { commentsTab, reactionsTab, transcriptTab } from './tabs';
import { useVideoPlayer } from '../../../video/hooks';
import { Video } from '../Video/Video';
import { useClip } from '../../contexts/clip/hook';

export const VideoAndTranscript: React.FC = () => {
  const { setContainerRef } = useVideoPlayer();

  return (
    <Card>
      <VideoContainer ref={setContainerRef}>
        <Video />
      </VideoContainer>
      <TabsBar
        defaultKey="transcript"
        items={[transcriptTab, commentsTab, reactionsTab]}
        onTabChange={() => null}
      />
    </Card>
  );
};
